import { connect } from "react-redux";

import { setModalLoaderVisibility } from "store/common/modal-window/modal-window-slices";

import AddNewPartner from "./AddNewPartner";

const mapStateToProps = () => {
    return {};
};

const AddNewPartnerContainer = connect(mapStateToProps, {
    setModalLoaderVisibility,
})(AddNewPartner);

export default AddNewPartnerContainer;
